// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-screen {
  width: 100%;
  height: 100%;
}
.login-screen .userList {
  display: flex;
}
.login-screen .row {
  display: flex;
  width: 100%;
  height: 100vh;
}
.login-screen .row .col {
  align-items: center;
  justify-content: space-between;
  width: 100%;
  display: flex;
  padding-left: 50px;
}
.login-screen .row .col:nth-child(1) {
  justify-content: center;
  background-color: #0168bf;
  padding-left: 0;
}
.login-screen .row .col h2 {
  font-size: 25px;
  line-height: 33px;
  color: #0168bf;
  font-weight: 900;
  margin: 0px 0 20px;
}
.login-screen .row .col .form-label {
  font-weight: 400;
  font-size: 18px;
  line-height: 28px;
  color: #5f5f5f;
  font-family: "Montserrat" !important;
}
.login-screen .row .col .form-control {
  width: 460px;
  background: #f3f3f3;
  border-radius: 6px;
}
.login-screen .row .col .form-control:focus {
  background-color: #ffffff !important;
}
.login-screen .row .col .btn-primary {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 14px 42px;
  gap: 12px;
  font-size: 18px;
  width: 134px;
  height: 42px;
  margin: 20px 0;
  background: #367dce;
  border-radius: 4px;
  /* Inside auto layout */
  flex: none;
  order: 0;
  flex-grow: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/UserLogin/index.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;AACF;AAAE;EACE,aAAA;AAEJ;AAAE;EACE,aAAA;EACA,WAAA;EACA,aAAA;AAEJ;AADI;EACE,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;AAGN;AAFM;EACE,uBAAA;EACA,yBAAA;EACA,eAAA;AAIR;AAFM;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AAIR;AAFM;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,oCAAA;AAIR;AAFM;EACE,YAAA;EACA,mBAAA;EACA,kBAAA;AAIR;AAFM;EACE,oCAAA;AAIR;AAFM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,uBAAA;EAEA,UAAA;EACA,QAAA;EACA,YAAA;AAGR","sourcesContent":[".login-screen {\n  width: 100%;\n  height: 100%;\n  .userList {\n    display: flex;\n  }\n  .row {\n    display: flex;\n    width: 100%;\n    height: 100vh;\n    .col {\n      align-items: center;\n      justify-content: space-between;\n      width: 100%;\n      display: flex;\n      padding-left: 50px;\n      &:nth-child(1) {\n        justify-content: center;\n        background-color: #0168bf;\n        padding-left: 0;\n      }\n      h2 {\n        font-size: 25px;\n        line-height: 33px;\n        color: #0168bf;\n        font-weight: 900;\n        margin: 0px 0 20px;\n      }\n      .form-label {\n        font-weight: 400;\n        font-size: 18px;\n        line-height: 28px;\n        color: #5f5f5f;\n        font-family: \"Montserrat\" !important;\n      }\n      .form-control {\n        width: 460px;\n        background: #f3f3f3;\n        border-radius: 6px;\n      }\n      .form-control:focus {\n        background-color: #ffffff !important;\n      }\n      .btn-primary {\n        display: flex;\n        flex-direction: row;\n        justify-content: center;\n        align-items: center;\n        padding: 14px 42px;\n        gap: 12px;\n        font-size: 18px;\n        width: 134px;\n        height: 42px;\n        margin: 20px 0;\n        background: #367dce;\n        border-radius: 4px;\n        /* Inside auto layout */\n\n        flex: none;\n        order: 0;\n        flex-grow: 0;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
